/** Agent portal routes and permission boundaries */

export const AGENT_PORTAL_BASE = "/agent";

export const AGENT_ROUTES = {
  login: `${AGENT_PORTAL_BASE}/login`,
  bookings: `${AGENT_PORTAL_BASE}/bookings`,
  bookingDetail: (id: number | string) => `${AGENT_PORTAL_BASE}/bookings/${id}`,
  containers: `${AGENT_PORTAL_BASE}/containers`,
  containerDetail: (id: number | string) => `${AGENT_PORTAL_BASE}/containers/${id}`,
  masterContainers: `${AGENT_PORTAL_BASE}/master-bl-awb`,
  masterContainerDetail: (id: number | string) =>
    `${AGENT_PORTAL_BASE}/master-bl-awb/${id}`,
} as const;

/** Status tabs shown on the agent bookings list */
export const AGENT_BOOKING_STATUS_TABS = [
  { key: "all", label: "All" },
  { key: "approved", label: "Approved" },
  { key: "waiting_for_goods", label: "Waiting for goods" },
  { key: "goods_received_origin", label: "Received in warehouse" },
  { key: "in_transit", label: "In transit" },
] as const;

/** Statuses included when the "All" tab is selected */
export const AGENT_LIST_BOOKING_STATUSES = [
  "approved",
  "waiting_for_goods",
  "goods_received_origin",
  "in_transit",
] as const;

export type AgentListBookingStatus =
  (typeof AGENT_LIST_BOOKING_STATUSES)[number];

/** Hide goods-ready column on these list tabs / row statuses */
export const AGENT_GOODS_READY_HIDDEN_STATUSES = [
  "goods_received_origin",
  "in_transit",
] as const;

/** Default list size on the "All" tab (no status/company filter). */
export const AGENT_ALL_TAB_BOOKING_LIMIT = 1000;

/** Has-container filter on agent bookings list */
export const AGENT_HAS_CONTAINER_FILTER = [
  { value: "yes", label: "Has container" },
  { value: "no", label: "No container" },
] as const;

export type AgentHasContainerFilter =
  (typeof AGENT_HAS_CONTAINER_FILTER)[number]["value"];

/** Statuses an agent may set on a booking */
export const AGENT_EDITABLE_BOOKING_STATUSES = [
  "approved",
  "waiting_for_goods",
  "goods_received_origin",
  "in_transit",
] as const;

export type AgentEditableBookingStatus =
  (typeof AGENT_EDITABLE_BOOKING_STATUSES)[number];

export const AGENT_CONTAINER_STATUSES = [
  { value: "planned", label: "Planned" },
  { value: "departed", label: "Departed" },
  { value: "arrived", label: "Arrived" },
  { value: "customs", label: "Customs" },
  { value: "completed", label: "Completed" },
] as const;

/** Statuses agents may set via Master BL/AWB bulk update */
export const AGENT_MASTER_EDITABLE_CONTAINER_STATUSES = [
  { value: "planned", label: "Planned" },
  { value: "departed", label: "Departed" },
  { value: "arrived", label: "Arrived" },
] as const;

export type AgentMasterEditableContainerStatus =
  (typeof AGENT_MASTER_EDITABLE_CONTAINER_STATUSES)[number]["value"];

export const mapContainerStatusToBookingStatus = (
  containerStatus: string
): string => {
  if (containerStatus === "customs") return "customs_pending_clearance";
  if (["planned", "departed", "arrived"].includes(containerStatus)) {
    return "in_transit";
  }
  return containerStatus;
};
